var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',{staticStyle:{"textAlign":"center"}},[_vm._v("\n  Copyright © 2022 Geekchic All rights reserved. Inspired By Vue & Ant Design Vue\n")])}
var staticRenderFns = []

export { render, staticRenderFns }